module.exports = __webpack_public_path__ + "static/media/cy.132f9119.svg";